import { RootState } from "../../redux/configureStore";
import { createSelector } from "@reduxjs/toolkit";
import { FormattedChatMessage, FormattedConversation } from "../../app/types";

export function getConversation(
  topic: string,
): (state: RootState) => FormattedConversation | undefined {
  return (state) => state.conversations.entities[topic];
}

export function getConversationMessages(
  topic: string,
): (state: RootState) => FormattedChatMessage[] {
  return createSelector(getConversation(topic), (conversation) =>
    Object.values(conversation?.formattedMessages ?? {}).reverse(),
  );
}

export function getConversationQuestions(
  topic: string,
): (state: RootState) => FormattedChatMessage[] {
  return createSelector(getConversationMessages(topic), (messages) =>
    messages.filter((msg) => msg.isQuestion),
  );
}
